<script>
export default {
    data() {
        return {
            show: false,
        }
    },

    methods: {
        toggleMenu() {
            this.show = !this.show;
        },

        closeMenu() {
            this.show = false;
        },
    },
};
</script>
